module.exports = __webpack_public_path__ + "static/monday-lunch-909082ca3839b3c89f5ec4a6f1f33069.png";